import { abortController } from '../abortController'
import axios from 'axios'

export default VUE => {
  const IS_DUMMY_API = VUE.h.parseFalsy(VUE.h.env('VUE_APP_DUMMY_API', false))

  function fixPath(path) {
    let fixedPath = path
    // fixedPath = fixedPath.replace(/\/+/g, '/')
    // console.log('*FIXED_PATH' + fixedPath)
    return fixedPath
  }

  const REQUEST_POST = function(url, data) {
    return VUE.API.post(fixPath(url), data).catch(err => {
      console.log('*[REQUEST_POST err]', err)
      return err
    })
  }

  const REQUEST_GET = function(url, data) {
    return VUE.API.get(fixPath(url), data).catch(err => {
      console.log('*[REQUEST_GET err]', err)
      return err
    })
  }

  const REQUEST = function(url, func, controller) {
    let response = VUE.API.get(fixPath(url), {
      signal: !controller ? null : controller.signal,
    })
    return response
      .then(res => {
        // console.log('REQUEST', res)
        return res
      })
      .catch(err => {
        console.log('*[REQUEST err]', err)
        // todo: trigger error messsage
        if (/gadgets\//gm.test(err.config.url)) {
          VUE.APP.$router.push({ path: '/404' })
        }
        // VUE.APP.$router.push({ path: '/404' })
        // if (err.toString().includes('Network Error')) {
        //   // console.log('*NetworkError')
        //   return VUE.APP.$router.push({ path: '/404' })
        // } else {
        if (axios.isCancel(err)) {
          console.warn('Operation canceled')
        } else {
          func && func()
          return ''
        }
        //   if (!url.includes('category')) {
        //     VUE.APP.$router.push({ path: '/404' })
        //   } else {
        //     return ''
        //   }
        // }
      })
  }

  return {
    // debug action
    testApi: async context => {
      return new Promise((resolve, reject) => {
        // console.log('*[testApi]')
        /*VUE.API.get('/protected')
          .then(res => {
            console.log(VUE.h.dumpObj(res.data))
            context.commit(
              'setTestApiMsg',
              `*** ${VUE.h.dumpObj(res.data)} ${Date.now()} ***`
            )
            resolve()
          })
          .catch(err => {
            console.log('*[err]', err)
            reject()
          })*/
        REQUEST('/error')
          .then(res => {
            console.log('*[OK]', res)
            context.commit('setTestApiMsg', '*** SHALL NOT PASS ***')
            resolve()
          })
          .catch(err => {
            console.log('*[ERROR]', err)
            context.commit('setTestApiMsg', '*** ERROR CATCHED ***')
            reject()
          })
      })
    },

    setHeadline: ({ commit }, title) => {
      commit('setHeadline', title)
      // console.log('setHeadline',title)
      if (!title) {
        document.title = VUE.APP.$i18n.t('titleTemplate', { title })
      }
    },

    setBreadcrumbs: ({ commit }, v) => {
      commit('setBreadcrumbs', v)
    },

    setNotice: ({ commit }, notice) => {
      commit('setNotice', notice)
    },

    setNotices: ({ commit }, notices) => {
      commit('setNotices', notices)
    },

    addNotice: ({ commit }, notice) => {
      commit('addNotice', notice)
    },

    clearNotice: ({ commit }) => {
      // console.log('*[clearNotice]')
      commit('clearNotice')
    },

    clearNotices: ({ commit }) => {
      // console.log('*[clearNotices]')
      commit('clearNotices')
    },

    fetchInitData: async context => {
      return new Promise((resolve, reject) => {
        context.commit('setInitDataPending')
        // fixture mode
        if (
          IS_DUMMY_API ||
          VUE.h.parseFalsy(VUE.h.env('VUE_APP_DUMMY_INITDATA', 'false'))
        ) {
          // console.log('*[DUMMY INITDATA]')
          window.setTimeout(() => {
            let initData = require('@/assets/res/initData.json')
            if (VUE.h.parseFalsy(VUE.h.env('VUE_APP_DUMMY_HOME', 'false'))) {
              let slidersData = require('@/assets/res/sliders.json')
              Object.assign(initData, slidersData)
            }
            let categories = require('@/assets/res/categories.json')
            VUE.h.fixChildren(categories)
            VUE.h.fixProducts(categories)
            // console.log('*categories', VUE.h.dumpObj(categories))
            context.commit(
              'setInitData',
              Object.assign(initData, {
                categories,
              })
            )
          }, 3000)
          resolve()
        } else {
          // normal mode
          // console.log('*GET[/init-data]')
          REQUEST('/init-data')
            .then(res => {
              // console.log(VUE.h.dumpObj(res.data))
              if (res.data.categories) VUE.h.fixChildren(res.data.categories)
              if (VUE.h.parseFalsy(VUE.h.env('VUE_APP_DUMMY_HOME', 'true'))) {
                let slidersData = require('@/assets/res/sliders.json')
                Object.assign(res.data, slidersData)
              }
              context.commit('setInitData', res.data)
              resolve()
            })
            .catch(err => {
              console.log('*[err]', err)
              // todo: trigger error messsage
              context.commit('unsetInitDataPending')
              reject()
            })
        }
      })
    },

    fetchFilters: async ({ commit, state }) => {
      return new Promise((resolve, reject) => {
        if (Object.keys(state.filters).length) {
          resolve()
          return
        }
        // fixture mode
        if (
          IS_DUMMY_API ||
          VUE.h.parseFalsy(VUE.h.env('VUE_APP_DUMMY_FILTERS', 'false'))
        ) {
          // console.log('*[DUMMY FILTERS]')
          let filtersData = require('@/assets/res/filters.json')
          commit('setFilters', filtersData)
          resolve()
        } else {
          // normal mode
          // console.log('*GET[/filters]')
          REQUEST('/filters')
            .then(res => {
              commit('setFilters', res.data)
              resolve()
            })
            .catch(err => {
              // console.log('*[err]', err)
              // todo: trigger error messsage
              reject(err)
            })
        }
      })
    },

    resetFilters({ commit }) {
      commit('resetFilters')
    },

    resetScroll() {
      window.scrollTo(0, 0)
    },

    fetchCategory: async ({ commit, state }, path) => {
      return new Promise((resolve, reject) => {
        commit('setCategoryCurrentPath', path)
        let category = null
        let slugs = VUE.h.parsePath(path)
        if (slugs.length > 1) {
          let _c = state.categories
          slugs.forEach(slug => {
            if (!_c) return
            category = _c.find(c => c.slug === slug)
            if (category) {
              _c = category.children
            } else {
              _c = null
            }
          })
        } else {
          category = state.categories.find(c => c.slug === path)
        }
        ///console.log(category)
        //console.log(VUE.APP.$i18n)
        if (category) {
          if (!category[`used_text_block_${VUE.APP.$i18n.locale}`]) {
            category[`used_text_block_${VUE.APP.$i18n.locale}`] = ''
          }
          if (!category[`text_block_${VUE.APP.$i18n.locale}`]) {
            category[`text_block_${VUE.APP.$i18n.locale}`] = ''
          }
        } else {
          category = []
          category[`used_text_block_${VUE.APP.$i18n.locale}`] = ''
          category[`text_block_${VUE.APP.$i18n.locale}`] = ''
        }
        //console.log(category)
        // don't really fetch from backend, do mapping from initdata
        if (
          IS_DUMMY_API ||
          VUE.h.parseFalsy(VUE.h.env('VUE_APP_DUMMY_CATEGORIES', 'false'))
        ) {
          // console.log('*[DUMMY CATEGORIES]')
          if (category) {
            commit('setCategory', category)

            resolve()
          } else {
            reject('not found')
          }
        } else {
          // normal mode
          const pathEnc = path
            .split('/')
            .map(p => encodeURIComponent(p))
            .join('/')

          let pathFix = `/category/${pathEnc}`
          // pathFix = pathFix.split('?')[0]
          //console.log(pathFix)
          pathFix = pathFix.replace('/category/used/', '/used/category/')
          let params = {}
          if (state.category.sort) {
            params.order = state.category.sort
          }
          if (Object.keys(state.selectedFilters).length) {
            Object.keys(state.selectedFilters).forEach(filterSlug => {
              params[filterSlug] = state.selectedFilters[filterSlug]
            })
            if (!params.order) {
              params.order = 'price_asc'
            }
          }
          delete params['gclid']
          // console.log('params', params)
          let p = Object.keys(params)

          // console.log('*GET', params)
          // console.log(VUE.APP.$router.currentRoute.query)
          //let sg = Object.keys(VUE.APP.$router.currentRoute.query)

          if (p.length) {
            pathFix += '?' + p.map(key => key + '=' + params[key]).join('&')
          }

          if (
            !pathFix.includes('used-iphone') &&
            pathFix !== '/category/iphone' &&
            pathFix !== '/category/iphone/iphone-11' &&
            !p.length &&
            !params.order
          ) {
            pathFix += '?order=price_asc'
          }

          if (pathFix.includes('iphone-11')) {
            pathFix = pathFix.replace('order=price_asc', '')
            // console.log(pathFix)
          }

          REQUEST(
            pathFix,
            () => {
              // if reject
              reject()
            },
            {
              signal: abortController.getSignalToken(),
            }
          )
            .then(res => {
              // console.log('*[data]', res.data)
              // console.log(res)
              if (res.data) {
                if (!category) category = {}
                if (Array.isArray(res.data)) {
                  Object.assign(category, { products: res.data })
                } else if (res.data.products) {
                  Object.assign(category, { products: res.data.products })
                  if (res.data.filters) {
                    Object.assign(category, { filters: res.data.filters })
                  }
                } else {
                  category.products = []
                  category.filters = {}
                }
                commit('setCategory', category)
                commit('setCategoryTotalPages', res.data.count_products)
                resolve(category)
              }
              reject('not found')
            })
            .catch(e => {
              reject(e)
            })
        }
      })
    },

    resetPagination: ({ commit }) => {
      commit('setCategoryPage', 1)
    },

    fetchProduct: async ({ commit, state, dispatch }, path) => {
      // don't really fetch from backend, do mapping from initdata category.products
      return new Promise((resolve, reject) => {
        if (
          IS_DUMMY_API ||
          VUE.h.parseFalsy(VUE.h.env('VUE_APP_DUMMY_PRODUCTS', 'false'))
        ) {
          // console.log('*[DUMMY PRODUCT]')
          let p = path.split('/')
          if (p.length < 2) reject()
          let slug = p.pop()
          commit('setCategoryCurrentPath', p.join('/'))
          let rootCategorySlug = p.shift()
          let cat = state.categories.find(c => c.slug === rootCategorySlug)
          if (p.length) {
            p.forEach(slug => {
              let sk = cat.children.find(c => c.slug === slug)
              if (sk) {
                cat = sk
              } else {
                cat = null
              }
            })
          }
          if (cat) {
            let product = cat.products.find(p => p.slug === slug)
            if (product) {
              commit('setProduct', product)
              resolve()
            } else {
              reject()
            }
          } else {
            reject()
          }
        } else {
          // normal mode
          // console.log(`*GET[/product/${path}]`)
          const fetch = () => {
            REQUEST(`/product/${path}`)
              .then(res => {
                if (!res) {
                  return reject('Product not found')
                }

                // console.log(res.data)
                if (typeof res.data === 'object' && res.data !== null) {
                  if (res.data.product) {
                    if (Array.isArray(res.data.product)) {
                      if (res.data.product.length) {
                        commit('setProduct', res.data.product[0])
                      } else {
                        commit('setProduct', {})
                      }
                    } else {
                      commit('setProduct', res.data.product)
                    }
                  } else {
                    commit('setProduct', res.data)
                  }
                  if (res.data.products) {
                    commit('setCategory', { products: res.data.products })
                  }
                } else if (
                  Array.isArray(res.data) &&
                  res.data.length &&
                  typeof res.data[0] === 'object' &&
                  res.data[0].id
                ) {
                  commit('setProduct', res.data[0])
                }
                resolve()
              })
              .catch(err => {
                console.log('*[err]', err)
                // todo: trigger error messsage
                reject(err)
              })
          }
          // load all other products in same category
          if (
            VUE.h.parseFalsy(VUE.h.env('VUE_APP_EXPLORE_PRODUCTS', 'false'))
          ) {
            if (VUE.h.isNumeric(path)) {
              fetch()
            } else {
              let a = path.split('/')
              a.splice(-1, 1)
              const subPath = a.join('/')
              dispatch('fetchCategory', subPath).then(() => {
                fetch()
              })
            }
          } else {
            fetch()
          }
        }
      })
    },

    fetchSearch: async ({ commit }, term) => {
      return new Promise((resolve, reject) => {
        commit('setSearchQuery', term)
        REQUEST(`search?q=${term}`)
          .then(res => {
            commit('setSearchResults', res.data)
            resolve()
          })
          .catch(err => {
            console.log('*[err]', err)
            // todo: trigger error messsage
            reject()
          })
      })
    },

    fetchFlySearch: async (_, term) => {
      return new Promise((resolve, reject) => {
        REQUEST_GET(`search?q=${term}`)
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            console.log('*[err] fetchFlySearch', err)

            if (err?.response?.status === 404) {
              resolve(err?.response?.data?.products)
            }

            reject(err)
          })
      })
    },

    fetchTradein: async ({ commit, state }) => {
      return new Promise((resolve, reject) => {
        if (Object.keys(state.tradeIn).length) {
          resolve()
          return
        }
        // dummy data
        if (VUE.h.parseFalsy(VUE.h.env('VUE_APP_DUMMY_TRADEIN', 'false'))) {
          const data = require('@/assets/res/tradeinConfig.json')
          commit('setTradeIn', data)
          resolve()
        } else {
          // normal mode
          REQUEST('trade-in')
            .then(res => {
              commit('setTradeIn', res.data)
              resolve()
            })
            .catch(err => {
              console.log('*[err]', err)
              // todo: trigger error messsage
              reject()
            })
        }
      })
    },

    fetchRepair: async ({ commit, state }) => {
      return new Promise((resolve, reject) => {
        if (Object.keys(state.repair).length) {
          resolve()
          return
        }
        // normal mode
        REQUEST('repair')
          .then(res => {
            commit('setRepair', res.data)
            resolve()
          })
          .catch(err => {
            console.log('*[err]', err)
            // todo: trigger error messsage
            reject()
          })
      })
    },

    addToCart: async ({ state, commit }, payload) => {
      console.log('*[CART_ADD]', state.cart, payload)
      return new Promise((resolve, reject) => {
        if (payload.id) {
          commit('addCartItem', payload)
          commit('setAddedNotice', true)
          resolve()
        } else {
          reject()
        }
      })
    },

    removeFromCart: async ({ commit }, id) => {
      return new Promise(resolve => {
        commit('removeCartItem', id)
        resolve()
      })
    },

    setCartItemQty: ({ commit }, { id, qty }) => {
      commit('setCartItemQty', { id, qty })
    },

    removeWarranty: ({ commit }, id) => {
      commit('removeWarranty', id)
    },

    setAddedCartNotice: ({ commit }) => {
      commit('setAddedNotice', true)
    },

    unsetAddedCartNotice: ({ commit }) => {
      commit('setAddedNotice', false)
    },

    changeLang: ({ commit }, lang) => {
      commit('setLanguage', lang)
    },

    // redirect to parent category
    doCategoryUplift: ({ commit }) => {
      commit('setDeferredFilters')
      if (
        VUE.APP.$router.currentRoute.path.indexOf('/product-category') === 0
      ) {
        let a = VUE.APP.$router.currentRoute.path.split('/')
        if (a.length > 3) {
          VUE.APP.$router.push(a.slice(0, 3).join('/'))
        }
      }
    },

    submitOrder: async ({ commit }, payload) => {
      // console.log('*[ORDER]', payload)
      let order = {}
      Object.assign(order, payload, { created: Date.now() })
      // return Promise.resolve({})
      console.log('*[ORDER]', order)
      return new Promise((resolve, reject) => {
        REQUEST_POST('order', order)
          .then(res => {
            // console.log('*[ORDER DONE]', res.data)
            commit('setOrder', res.data)
            resolve(res)
          })
          .catch(err => {
            console.log('*[ORDER ERROR]', err)
            reject(err)
          })
      })
    },

    completeOrder: async ({ commit }, payload) => {
      let data = {
        payment: {
          id: payload.id,
          status: payload.status,
        },
      }
      return new Promise((resolve, reject) => {
        REQUEST_POST(`/order/${payload.order_id}`)
          .then(res => {
            commit('completeOrder', data)
            resolve(res)
          })
          .catch(err => {
            console.log('*[err]', err)
            // todo: trigger error messsage
            reject()
          })
      })
    },

    getOrder: async ({ commit }, id) => {
      return new Promise((resolve, reject) => {
        REQUEST(`order/${id}`)
          .then(res => {
            commit('setOrder', res.data)
            resolve(res.data)
          })
          .catch(err => {
            console.log('*[err]', err)
            // todo: trigger error messsage
            reject()
          })
      })
    },
    getPaymentSubmitUrl: async ({ dispatch }, payload) => {
      return new Promise((resolve, reject) => {
        // console.log(method)
        const method = payload.method
        REQUEST_POST(`credentials/${method}`, { data: payload.order })
          .then(res => {
            // console.log(res)
            if (res.data) {
              // console.log(res.data.link)
              dispatch('setPaymentSubmitData', res.data)
              resolve(res.data)
            } else {
              // console.log('err in else block')
              reject()
            }
          })
          .catch(err => {
            console.log('*[err] from catch block', err)
            // todo: trigger error messsage
            reject(err)
          })
      })
    },

    getPaymentTransfer: async ({ dispatch }, payload) => {
      let method = payload.method
      return new Promise((resolve, reject) => {
        // console.log(method)
        REQUEST_POST(`credentials/${method}`, payload.order)
          .then(res => {
            // console.log(res)
            if (res.data) {
              // console.log(res.data.link)
              dispatch('setPaymentTransferData', res.data)
              resolve(res.data)
            } else {
              // console.log('err in else block')
              reject()
            }
          })
          .catch(err => {
            console.log('*[err] from catch block', err)
            // todo: trigger error messsage
            reject(err)
          })
      })
    },
    getPaymentRedirectUrl: async ({ dispatch }, payload) => {
      const method = payload.method.split('_')[0]
      return new Promise((resolve, reject) => {
        // console.log(method)
        REQUEST_POST(`credentials/${method}`, payload.order)
          .then(res => {
            // console.log(res)
            if (res.data && res.data.link) {
              // console.log(res.data.link)
              dispatch('setPaymentRedirectUrl', res.data.link)
              resolve(res.data.link)
            } else {
              // console.log('err in else block')
              reject(new Error('Something is not good with response'))
            }
          })
          .catch(err => {
            console.log('*[err] from catch block', err)
            // todo: trigger error messsage
            reject(err)
          })
      })
    },
    getPaymentStatus: async ({ commit }, payload) => {
      const order = {
        order_id: payload.order_id,
        phone: payload.phone,
        amount: payload.amount,
        created: new Date(),
        partsCount: payload.partsCount,
        products: payload.products,
      }
      return new Promise((resolve, reject) => {
        REQUEST_POST(`credentials/${payload.method}`, order)
          .then(res => {
            if (res.data) {
              commit('setPaymentResult', res.data)
              resolve(res.data)
            } else {
              reject(res)
            }
          })
          .catch(err => {
            console.log('*[err]', err)
            reject(err)
          })
      })
    },

    submitQuickOrder: async ({ dispatch }, payload) => {
      return new Promise((resolve, reject) => {
        // console.log('*[QUICK ORDER]', payload)
        let data = { type: 'quickorder' }
        Object.assign(data, payload)
        VUE.APP.$gtag.event('fast_click', {
          event_category: 'checkout',
          event_label: 'Buy',
        })
        dispatch('submitAppeal', data)
          .then(() => {
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },

    submitPreOrder: async ({ dispatch }, payload) => {
      return new Promise((resolve, reject) => {
        // console.log('*[PREORDER]', payload)
        let data = { type: 'preorder' }
        Object.assign(data, payload)
        dispatch('submitAppeal', data)
          .then(() => {
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },

    submitNotifyStock: async ({ dispatch }, payload) => {
      return new Promise((resolve, reject) => {
        // console.log('*[NOTIFY STOCK]', payload)
        let data = { type: 'notifystock' }
        Object.assign(data, payload)
        dispatch('submitAppeal', data)
          .then(() => {
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },

    submitContactForm: async ({ dispatch }, payload) => {
      return new Promise((resolve, reject) => {
        // console.log('*[CONTACT FORM]', payload)
        let data = { type: 'contact-form' }
        Object.assign(data, payload)
        dispatch('submitAppeal', data)
          .then(() => {
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },

    submitFranchiseForm: async ({ commit }, payload) => {
      let data = {
        // created: Date.now(),
      }
      Object.assign(data, payload)
      return new Promise((resolve, reject) => {
        REQUEST_POST('/franchise', data)
          // let data = { type: 'franchise-form' }
          // Object.assign(data, payload)
          .then(res => {
            if (res.data) {
              commit('setFranchise', res.data)
              resolve(res.data)
            } else {
              reject()
            }
          })
          .catch(err => {
            console.log('*[err]', err)
            // todo: trigger error messsage
            reject()
          })
      })
    },

    /*
      name,
      phone,
      message,
      type: // quickorder|preorder|notifystock
      product
    */
    submitAppeal: async ({ commit }, payload) => {
      let data = {
        created: Date.now(),
      }
      Object.assign(data, payload)
      // console.log('*[submitAppeal]', data)
      // commit('setAppealResult', { success: true })
      // return Promise.resolve({})
      return new Promise((resolve, reject) => {
        REQUEST_POST('appeal', data)
          .then(res => {
            commit('setAppealResult', res.data)
            resolve()
          })
          .catch(err => {
            console.log('*[err]', err)
            // todo: trigger error messsage
            reject()
          })
      })
    },

    /*
    name,
    phone,
    product,
    content,
    rating,
    */
    submitReview: async ({ commit }, payload) => {
      let data = {
        created: Date.now(),
      }
      Object.assign(data, payload)
      // console.log('*[submitReview]', data)
      return new Promise((resolve, reject) => {
        REQUEST_POST('review', data)
          .then(() => {
            commit('appendReview', payload)
            resolve()
          })
          .catch(err => {
            console.log('*[err]', err)
            // todo: trigger error messsage
            reject()
          })
      })
    },

    fetchDeliveryCity: async ({ commit }, query) => {
      return new Promise((resolve, reject) => {
        REQUEST(`city?q=${query}`)
          .then(res => {
            if (res && res.data && res.data.data && res.data.data.length) {
              console.log('setDeliveryCityRefs *[city]', res.data.data)
              commit('setDeliveryCityRefs', res.data.data)
              resolve()
            } else {
              console.log('fetchDeliveryCity *[err]', 'No data')
              reject()
            }
          })
          .catch(err => {
            console.log('fetchDeliveryCity *[err]', err)
            // todo: trigger error messsage
            reject()
          })
      })
    },

    fetchDeliveryDepartment: async ({ commit }, ref) => {
      // const ref = 'e718a680-4b33-11e4-ab6d-005056801329'
      return new Promise((resolve, reject) => {
        REQUEST(`warehouse/?ref=${ref}`)
          .then(res => {
            // console.log('fetchDeliveryDepartment *[warehouse]', res.data)
            const data = res.data.data.map(d => ({
              Description: d.Description,
              DescriptionRu: d.DescriptionRu,
              AreaDescriptionRu: d.AreaDescriptionRu,
              AreaDescription: d.AreaDescription,
            }))
            // console.log('fetchDeliveryDepartment2 *[warehouse]', data)
            commit('setDeliveryDepartmentRefs', data)
            resolve()
          })
          .catch(err => {
            console.log('fetchDeliveryDepartment *[err]', err)
            // todo: trigger error messsage
            reject()
          })
      })
    },

    fetchPost: async ({ commit }, slug) => {
      return new Promise((resolve, reject) => {
        REQUEST(`posts/${slug}`)
          .then(res => {
            console.log('*[fetchPost]', res.data)
            if (Array.isArray(res.data.posts)) {
              commit('setBlog', res.data.posts)
              commit('setPostTotalPages', res.data.count_posts)
              commit('setPostPage', res.data.curent_page)
              commit('setPostPerPage', res.data.curent_limit * 1)
              resolve()
            } else {
              console.log('*[no post]', slug)
              reject()
            }
          })
          .catch(err => {
            console.log('*[err]', err)
            // todo: trigger error messsage
            reject()
          })
      })
    },

    fetchBlog: async ({ commit }) => {
      return new Promise((resolve, reject) => {
        if (
          IS_DUMMY_API ||
          VUE.h.parseFalsy(VUE.h.env('VUE_APP_DUMMY_BLOG'), 'true')
        ) {
          // console.log('*DUMMY BLOG')
          const data = require('@/assets/res/blog.json')
          commit('setBlog', data)
          resolve()
        } else {
          REQUEST('posts/?limit=10')
            .then(res => {
              console.log('*[fetchBlog]', res.data)
              if (Array.isArray(res.data.posts)) {
                commit('setBlog', res.data.posts)
                commit('setPostTotalPages', res.data.count_posts)
                commit('setPostPage', res.data.curent_page)
                commit('setPostPerPage', res.data.curent_limit * 1)
                resolve()
              } else {
                // console.log('*[no posts in blog]')
                reject()
              }
            })
            .catch(err => {
              console.log('*[err]', err)
              // todo: trigger error messsage
              reject()
            })
        }
      })
    },

    fetchPagination: async ({ commit, state }, path) => {
      return new Promise((resolve, reject) => {
        let pathFix = path
        let params = {}
        if (state.category.sort) {
          params.order = state.category.sort
        }
        if (Object.keys(state.selectedFilters).length) {
          Object.keys(state.selectedFilters).forEach(filterSlug => {
            params[filterSlug] = state.selectedFilters[filterSlug]
          })
          if (!params.order) {
            params.order = 'price_asc'
          }
        }
        if (Object.keys(VUE.APP.$router.currentRoute.query).length) {
          // eslint-disable-next-line no-unused-vars
          const { page, ...other } = VUE.APP.$router.currentRoute.query
          params = Object.assign(params, other)
        }
        delete params['gclid']
        let p = Object.keys(params)
        pathFix = pathFix.replace('/category/used/', '/used/category/')
        // console.log('*GET', params)
        // console.log(VUE.APP.$router.currentRoute.query)
        //let sg = Object.keys(VUE.APP.$router.currentRoute.query)

        if (p.length) {
          pathFix += '&' + p.map(key => key + '=' + params[key]).join('&')
        }
        REQUEST(pathFix)
          .then(res => {
            // console.log(res)
            // console.log('*[data]', res.data)
            let category = {}
            if (res.data) {
              if (Array.isArray(res.data)) {
                Object.assign(category, { products: res.data })
              } else if (res.data.products) {
                Object.assign(category, { products: res.data.products })
                if (res.data.filters) {
                  Object.assign(category, { filters: res.data.filters })
                }
              } else {
                category.products = []
                category.filters = {}
              }
              commit('setCategory', category)
              commit('setCategoryTotalPages', res.data.count_products)
            }
            // console.log(category)
            resolve(category)
          })
          .catch(e => {
            reject(e)
          })
      })
    },

    fetchCategoryPricesBlock: async (_, path) => {
      return new Promise((resolve, reject) => {
        REQUEST(path)
          .then(res => {
            console.log('*[fetchCategoryPricesBlock]', res.data)
            resolve(res.data)
          })
          .catch(e => {
            reject(e)
          })
      })
    },

    fetchBlogPagination: async ({ commit }, path) => {
      REQUEST(path).then(res => {
        if (res.data) {
          console.log(res.data)
          commit('setBlog', res.data.posts)
          commit('setPostTotalPages', res.data.count_posts)
          commit('setPostPage', res.data.curent_page)
          commit('setPostPerPage', res.data.curent_limit * 1)
        }
      })
    },
  }
}
